import SignUpFormComponent, { Fields, Submit, Errors } from './SignUpForm'

export const SignUpForm = Object.assign(SignUpFormComponent, {
  Fields,
  Submit,
  Errors,
})
